module.exports = __webpack_public_path__ + "img/tr.48acda27.png";